<template>
    <div class="widget welcome-widget">
        <div class="content">
            <h3>Hi, {{ user.name }}! Welcome to Fusebox.</h3>
            <p>Your account is ready to use but not quite complete! We’d still like to know more about you and your show. To finish your profile, click the button below. Thanks!</p>
            <base-submit-button
                class="btn"
                @click="changeUIState({ isOnboardingModalVisible: true });"
            >
                Let’s Get Started
            </base-submit-button>
        </div>
        <div
            class="welcome-image"
        >
            <svg-vue icon="home-welcome" />
        </div>
    </div>
</template>

<script>
import {
    mapMutations,
    mapState,

} from 'vuex';

export default {
    computed: {
        ...mapState(['user']),
    },

    methods: {
        ...mapMutations(['changeUIState']),
    },
};
</script>
